import { KilowantContract } from "../entity/KilowantContract";
import { SellOffer } from "../entity/SellOffer";
import { BuyOffer } from "../entity/BuyOffer";
import { DiffBenchmark } from "./DiffBenchmark";
import { SavingsInfo } from "./SavingsInfo";
import { Pair } from "./Pair";
import { Stats } from "./Stats";


export class OffersData {
    offer: SellOffer;
    diff30: number | null;
    diff90: number | null;
    priceStats: Stats | null;
    savings: { [id in DiffBenchmark]: SavingsInfo };
}
